import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import styled from 'styled-components';

import { offerCode } from '../../../utils/bindings/offerCode';
import deliveryTypeBinding from '../../../utils/bindings/deliveryType';

const Section = {
  Title: styled.strong`
    font-weight: 800;
    font-size: 1.1em;
    margin-bottom: 10px;
  `
};

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.07)'
    }
  }
}));

const DeliveryInformationsCard = ({
  command,
  handleOpenDialogConfirmation,
  setSelectedCommandInformations,
  isActionCard
}) => {
  const classes = useStyles();
  return (
    <Paper
      className={classes.paper}
      onClick={() => {
        if (isActionCard) {
          setSelectedCommandInformations(command);
          handleOpenDialogConfirmation();
        }
      }}
    >
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Section.Title>Informations de Livraison : </Section.Title>
          <div>
            {`Offre de livraison : ${
              offerCode.find(element => element.value === command.offer.code)
                .name
            }`}
          </div>
          <div>
            {`Type de livraison : ${
              deliveryTypeBinding.find(
                element => element.value === command.deliveryType
              ).name
            }`}
          </div>
        </Grid>
        <Grid item md={6}>
          <Section.Title>Information destinataire : </Section.Title>
          <div>Email : {command.recipientEmail}</div>
          <div>Téléphone : {command.recipientPhoneNumber}</div>
          <div>Nom : {command.recipientLastname}</div>
          <div>Prénom : {command.recipientFirstname}</div>
        </Grid>
        <Grid item md={6}>
          <Section.Title>Adresse destinataire : </Section.Title>
          <div>Rue 1 : {command.recipientAddress.street}</div>
          <div>Rue 2 : {command.recipientAddress.street2}</div>
          <div>Ville : {command.recipientAddress.city}</div>
          <div>Entreprise : {command.recipientCompanyName}</div>
          <div>code postal : {command.recipientAddress.postalCode}</div>
          <div>Pays : {command.recipientAddress.country}</div>
        </Grid>
      </Grid>
    </Paper>
  );
};

DeliveryInformationsCard.propTypes = {
  command: PropTypes.object.isRequired,
  handleOpenDialogConfirmation: PropTypes.func,
  setSelectedCommandInformations: PropTypes.func,
  isActionCard: PropTypes.bool
};

export default DeliveryInformationsCard;
